import { NavBar } from "antd-mobile";
import { LeftOutline } from "antd-mobile-icons";
import { useNavigate } from "react-router-dom";

export const Header: React.FC<{
    title: string;
    backRoute?: string;
    onBack?: () => void;
}> = ({
          title,
          backRoute,
          onBack,
      }) => {
    const navigate = useNavigate();
    const handleBack = () => {
        if (onBack) {
            onBack();
            return;
        }
        const route = backRoute || "/pda/home";
        navigate(route);
    };
    return (
        <NavBar backIcon={<LeftOutline />} onBack={handleBack}>{title}</NavBar>
    )
}